module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "contact card-container"
  }, [_h('div', {
    staticClass: "card two-times"
  }, [_h('div', {
    staticClass: "card-header"
  }, [_h('h4', {
    staticClass: "card-title"
  }, ["お問い合わせ"])]), " ", _h('div', {
    staticClass: "card-body"
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('label', {
    staticClass: "form-label",
    attrs: {
      "for": "subject"
    }
  }, ["件名"]), " ", _h('input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "subject",
      "placeholder": "件名を入力してください。"
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', {
    staticClass: "form-label",
    attrs: {
      "for": "name"
    }
  }, ["お名前"]), " ", _h('input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "お名前を入力してください。"
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', {
    staticClass: "form-label",
    attrs: {
      "for": "email"
    }
  }, ["Eメール"]), " ", _h('input', {
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "お名前を入力してください。"
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', {
    staticClass: "form-label",
    attrs: {
      "for": "message"
    }
  }, ["メッセージ"]), " ", _h('textarea', {
    staticClass: "form-input",
    attrs: {
      "id": "message",
      "placeholder": "お名前を入力してください。",
      "rows": "6"
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_h('label', {
    staticClass: "form-checkbox"
  }, [_h('input', {
    attrs: {
      "type": "checkbox"
    }
  }), " ", _h('i', {
    staticClass: "form-icon"
  }), " 自分にもメールを送信する\n        "])])]), " ", _h('div', {
    staticClass: "card-footer text-center"
  }, [_h('a', {
    staticClass: "btn"
  }, ["確認する"])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fc9ddfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/Contact.vue
// module id = 429
// module chunks = 0